import { holidayAffectNewContainerDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getholidayAffectNewContainerEn = () => {
  const data = holidayAffectNewContainerDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addholidayAffectNewContainer = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-will-holidays-affect-delivery-of-my-new-container`,
    ) &&
    document.getElementById(`holidayAffectNewContainerJSONLD`) === null
  ) {
    const script = holidayAffectNewContainerJSONLDEn()
    addJSONLDToHead(script, `holidayAffectNewContainerJSONLD`)
  } else {
    removeElement(`holidayAffectNewContainerJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const holidayAffectNewContainerJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getholidayAffectNewContainerEn(),
  }
  return FaqBagsterTemplate
}
